// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"459434f0","126":"49b14b01","453":"af369bff","982":"ab519358"}[chunkId] + ".chunk.js";
};